import React, { useState } from 'react';

import { useContentRequirementsContext } from 'src/application/features/RestrictNavigation/ContentRequirementsProvider';

import { ExistingStudentWidgetProps } from '../Widget';
import { ListWidget as ListWidgetModel } from '@ael/core-api';
import { Checkbox } from '@ael/shared-components-library';
import classNames from 'classnames';

import './ListWidget.scss';

export const ListWidget = (props: ExistingStudentWidgetProps) => {
  const widget = props.widget as ListWidgetModel;

  const [checkedItems, setCheckedItems] = useState<boolean[]>(new Array(widget.value.data.texts.length).fill(false));

  const { submitWidget, fulfilled } = useContentRequirementsContext();
  const fulfillCurrentWidget = () => submitWidget(widget, true);

  const handleCheckboxToggle = (index: number) => {
    setCheckedItems((prev) => {
      const newCheckedItems = [...prev];

      newCheckedItems[index] = !newCheckedItems[index];

      if (!fulfilled && newCheckedItems.every((item) => item)) {
        fulfillCurrentWidget();
      }
      return newCheckedItems;
    });
  };

  return (
    <div className="uno-w-full uno-px-4">
      <ol className="uno-clear-both uno-list-none">
        {widget.value.data.texts.map((text, index) => (
          <li
            key={index}
            className={classNames('uno-block uno-m-b-[30px] uno-relative', {
              'uno-p-l-14': widget.value.properties.indent === 's',
              'uno-p-l-18': widget.value.properties.indent === 'm',
              'uno-p-l-22': widget.value.properties.indent === 'l',
            })}
          >
            <>
              {widget.value.properties.type === 'bulleted' && (
                <div
                  className={classNames(
                    'uno-absolute uno-top-0 uno-left-0 uno-rounded-[40px]',
                    'uno-m-l-[10px] uno-m-t-[6px] uno-h-[10px] uno-w-[10px]'
                  )}
                  style={{ background: widget.value.properties.color }}
                />
              )}
              {widget.value.properties.type === 'numbered' && (
                <div
                  className={classNames(
                    'uno-absolute uno-top-0 uno-left-0 uno-rounded-[40px]',
                    'uno-m-t-[-4px] uno-h-[30px] uno-w-[30px]',
                    'uno-text-base uno-p-t-[3px] uno-font-bold uno-text-center uno-text-black'
                  )}
                  style={{ background: widget.value.properties.color }}
                >
                  {index + 1}
                </div>
              )}
              {widget.value.properties.type === 'checkbox' && (
                <div
                  className={classNames(
                    'uno-absolute uno-top--1 uno-left-0',
                    'uno-m-l-[10px] uno-h-[10px] uno-w-[10px]'
                  )}
                >
                  <Checkbox big value={checkedItems[index]} onClick={() => handleCheckboxToggle(index)} label="" />
                </div>
              )}
              <div
                className="list-widget"
                onClick={widget.value.properties.type === 'checkbox' ? () => handleCheckboxToggle(index) : undefined}
                dangerouslySetInnerHTML={{ __html: text || '<p>&nbsp;</p>' }}
              ></div>
            </>
          </li>
        ))}
      </ol>
    </div>
  );
};
